import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { GALLERY } from "@/lib/constants";
import Reveal from "@/components/Reveal";
import Lightbox from "@/components/Lightbox";
// import { getGallery } from "@/lib/api";

export default function Gallery() {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [images, setImages] = useState(GALLERY); // fallback string[]

  // useEffect(() => {
  //   let mounted = true;
  //   getGallery()
  //     .then((data) => {
  //       if (mounted && Array.isArray(data) && data.length > 0) {
  //         setImages(data.map((d) => d.url));
  //       }
  //     })
  //     .catch(() => {});
  //   return () => { mounted = false; };
  // }, []);

  const openAt = (i) => { setIndex(i); setOpen(true); };
  const close = () => setOpen(false);
  const prev = () => setIndex((i) => (i - 1 + images.length) % images.length);
  const next = () => setIndex((i) => (i + 1) % images.length);

  return (
    <div data-testid="gallery-page" className="relative pt-32 pb-24 px-5 md:px-10">
      <Reveal className="text-center max-w-3xl mx-auto">
        <p className="text-[0.65rem] uppercase tracking-[0.5em] text-gold mb-4">
          A Visual Diary
        </p>
        <h1 className="font-serif font-light text-5xl md:text-7xl text-ivory leading-tight">
          Memories of <span className="italic gold-text">#PandA</span>
        </h1>
        <div className="ornament-divider w-72 mx-auto mt-8">
          <Heart size={14} className="text-gold/80 fill-gold/80" />
        </div>
        <p className="mt-6 font-serif italic text-lg md:text-xl text-ivory-muted">
          Tap any image to step inside the moment.
        </p>
      </Reveal>

      <div className="masonry max-w-7xl mx-auto mt-16">
        {images.map((src, i) => (
          <Reveal key={src + i} delay={(i % 6) * 80} className="item">
            <button
              type="button"
              onClick={() => openAt(i)}
              data-testid={`gallery-tile-${i}`}
              className="group relative w-full overflow-hidden rounded-2xl border border-gold/15 hover:border-gold/60 transition-all duration-500 block"
            >
              <img
                src={src}
                alt={`Gallery memory ${i + 1}`}
                loading="lazy"
                className="w-full h-auto block object-cover transition-transform duration-[1100ms] group-hover:scale-110"
              />
              <span
                aria-hidden="true"
                className="absolute inset-0 bg-gradient-to-t from-ink-900/80 via-ink-900/10 to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-500"
              />
              <span className="absolute bottom-3 left-3 right-3 flex items-center justify-between opacity-0 group-hover:opacity-100 translate-y-3 group-hover:translate-y-0 transition-all duration-500">
                <span className="font-serif italic text-gold-light text-base">
                  #PandA
                </span>
                <span className="text-[0.55rem] uppercase tracking-[0.4em] text-ivory">
                  View
                </span>
              </span>
            </button>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-20 text-center">
        <p className="font-serif italic text-2xl md:text-3xl hashtag-glow">
          Every frame, a heartbeat — #PandA
        </p>
      </Reveal>

      {open && (
        <Lightbox
          images={images}
          index={index}
          onClose={close}
          onPrev={prev}
          onNext={next}
        />
      )}
    </div>
  );
}
